export enum PromotionTypes {
  SET_PROMOTION = 'SET_PROMOTION',
  GET_PROMOTION = 'GET_PROMOTION',
}
